import { render, staticRenderFns } from "./TheList.vue?vue&type=template&id=c5e284b2&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=js"
export * from "./TheList.vue?vue&type=script&lang=js"
import style0 from "./TheList.vue?vue&type=style&index=0&id=c5e284b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e284b2",
  null
  
)

export default component.exports